import Button from "../../../Components/Button";
import classes from "./CreateCustomer.module.css";
import InputWithSearch from "../../../Components/InputWithSearch";
import {
  fetchSalesPersonByUserId,
  getUserDataById,
} from "../../../Services/Dashboard/tableGridService";
import { useState } from "react";

const CreateCustomer = ({ createCustomerFn, isLoading }) => {
  const [chState, setChState] = useState(null);
  const [customerData, setCustomerData] = useState(null);

  const onSearchFn = async (event) => {
    if (!event) {
      return;
    }
    try {
      const res = await fetchSalesPersonByUserId(event);
      const [chData] = res?.data?.data || [];
      setChState({ ...chData, chId: event });
    } catch (e) {
      throw e;
    }
  };
  const onCreateCustomer = () => {
    createCustomerFn({
      chData: chState,
      customerData
    });
  };

  const onSearchUserFn = async (event) => {
    try {
      const body = {
        input: {
          systemUserIds: [event],
        },
      };
     const res = await getUserDataById(body);
     const data = res?.data?.data;
     const [user] = data || [];
     setCustomerData(user);
    } catch (e) {
      throw e;
    }
  };

  return (
    <div className={classes["form-wrapper"]}>
      <div className={classes["form-group"]}>
        <label>User ID</label>
        <InputWithSearch type="number" onSearchFn={onSearchUserFn} />
      </div>
      <div className={classes["form-group"]}>
        <label>User Name</label>
        <input type="text" readOnly value={customerData?.name} />
      </div>
      <div className={classes["form-group"]}>
        <label>Realm ID</label>
        <input type="text" readOnly value={customerData?.realmId} />
      </div>
      <div className={classes["form-group"]}>
        <label>CH ID</label>
        <InputWithSearch type="number" onSearchFn={onSearchFn} />
      </div>
      <div className={classes["form-group"]}>
        <label>CH Name</label>
        <input type="text" value={chState?.empName} readOnly />
      </div>
      <Button
        disabled={!chState || !customerData || isLoading}
        onClick={onCreateCustomer}
      >
        {isLoading ? 'Loading' : 'Done'}
      </Button>
    </div>
  );
};

export default CreateCustomer;
